import type { NormalizeSubscriptionStatusParams, SubscriptionStatus } from '../types';

const SUBSCRIPTION_STATUSES: ReadonlySet<string> = new Set([
    'active',
    'trialing',
    'past_due',
    'canceled',
    'unpaid',
    'incomplete',
    'incomplete_expired',
    'paused',
    'none',
]);

const normalizeSubscriptionStatus = ({
    status,
}: NormalizeSubscriptionStatusParams): SubscriptionStatus =>
    SUBSCRIPTION_STATUSES.has(status) ? (status as SubscriptionStatus) : 'none';

export default normalizeSubscriptionStatus;
